'use strict';

// Extracted from EditPlaylistCtrl#save (see edit-playlist.js) so the
// create/patch payload shape can be unit tested without instantiating the
// Angular controller (matches the editAppConnect / save-force-emit pattern).

function playlistApps(selectedApps) {
    // we only want to save to the DB, appId, duration and slug
    return (selectedApps || []).map(function (app) {
        return { id: app.id, duration: app.duration, slug: app.slug };
    });
}

function buildCreatePlaylistPayload(playlist, selectedApps, totalDuration) {
    return {
        name: playlist.name,
        // Falls back to 'basic' because the "advanced" tab is currently
        // disabled in edit-playlist.html, so a new playlist never has
        // playlist.type set before save(). Previously this was hardcoded to
        // 'basic' unconditionally, silently discarding playlist.type if it
        // were ever populated (unlike the update payload, which always used
        // playlist.type). Falling back only when unset keeps both today's
        // behavior and future support for advanced playlists consistent.
        type: playlist.type || 'basic',
        apps: playlistApps(selectedApps),
        duration: totalDuration,
    };
}

function buildUpdatePlaylistPayload(playlist, selectedApps, totalDuration) {
    return {
        apps: playlistApps(selectedApps),
        name: playlist.name,
        type: playlist.type,
        duration: totalDuration,
    };
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = {
        playlistApps: playlistApps,
        buildCreatePlaylistPayload: buildCreatePlaylistPayload,
        buildUpdatePlaylistPayload: buildUpdatePlaylistPayload,
    };
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('playlistSavePayload', {
        playlistApps: playlistApps,
        buildCreatePlaylistPayload: buildCreatePlaylistPayload,
        buildUpdatePlaylistPayload: buildUpdatePlaylistPayload,
    });
}
